<div class="row">
	<div class="col d-flex align-items-center">
		<mat-icon>timer</mat-icon>&nbsp;&nbsp;<span class="clock-text" role="timer">{{ clock() }}</span>
	</div>
</div>
